module.exports = __webpack_public_path__ + "static/media/bg_feature_4.ce3bd525.jpg";